/**
 * Persistent operations over native maps (FE Arch 1.0 Step 2, #1166) — the map
 * counterpart of `sets.ts`: they never mutate their input, and return the input
 * itself when nothing changes.
 */

/** `m` with `key` set to `value`. */
export function mapWith<K, V>(m: ReadonlyMap<K, V>, key: K, value: V): ReadonlyMap<K, V> {
    if (m.has(key) && Object.is(m.get(key), value)) return m;
    const out = new Map(m);
    out.set(key, value);
    return out;
}

/** `m` without `key`. */
export function mapWithout<K, V>(m: ReadonlyMap<K, V>, key: K): ReadonlyMap<K, V> {
    if (!m.has(key)) return m;
    const out = new Map(m);
    out.delete(key);
    return out;
}
